/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import classNames from 'classnames';
import styles from './RadioButton.module.scss';

export interface RadioButtonProps {
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  label: string;
  disabled?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  value,
  label,
  checked,
  indeterminate = false,
  disabled,
  onChange,
}) => {
  return (
    <div className={classNames(styles.root, { [styles.indeterminate]: indeterminate, [styles.disabled]: disabled })}>
      <label className={styles.container}>
        <input disabled={disabled} value={value} type="radio" checked={checked} onChange={onChange} />
        <span className={styles.checkmark} />
      </label>
      <div className="typo-text-14 text-full">{label}</div>
    </div>
  );
};

export default RadioButton;
